import DeviceSizes from "./DeviceSizes";

const scrollTopBtns = document.querySelectorAll("#scroll-top, #scroll-top-tfbank-form");

function scrollFunction() {
	scrollTopBtns.forEach((btn) => {
		const scrollTopClass = btn.getAttribute('class');

		if ((scrollTopClass === 'desktop-scroll-top' && window.innerWidth < DeviceSizes.MD)
			|| (scrollTopClass === 'mobile-scroll-top' && window.innerWidth > DeviceSizes.MD)) {
			return;
		}

		if (document.body.scrollTop > 1000 || document.documentElement.scrollTop > 1000) {
			btn.style.display = "block";
		} else {
			btn.style.display = "none";
		}
	});
}

function topFunction(e) {
	e.preventDefault();
	window.scrollTo({ top: 0, behavior: 'smooth' });
}

// Module scope has no top-level `return`, so the early exit became a guard block.
if (scrollTopBtns.length) {
	window.onscroll = function() {
		scrollFunction();
	};

	scrollTopBtns.forEach((btn) => {
		btn.addEventListener("click", topFunction);
	});
}
